import { useEffect } from 'react'
import { Redirect, Route, Switch } from 'react-router'
import { useDispatch } from 'react-redux'

import getWallet from '../api/wallet'
import { updateWallet } from '../store/wallet/thunks'

import { PageContainer } from '../layout/PageContainer/PageContainer'
import { Home } from '../pages/Home/Home'
import { Gallery } from '../pages/Gallery/Gallery'
import { Market } from '../pages/Market/Market'
import { Wallet } from '../pages/Wallet/Wallet'
import { Profile } from '../pages/Profile/Profile'
import { Mint } from '../pages/Mint/Mint'
import { TokenView } from '../pages/TokenView/TokenView'
import CoolCats from '../api/contract'

export const App = () => {
  window.CoolCats = CoolCats;
  const dispatch = useDispatch()

  useEffect(() => {
    const interval = setInterval(() => {
      getWallet()
        .then(res => {
          dispatch(updateWallet(res));
        })
        .catch(console.log)
    }, 2000)

    return () => clearInterval(interval)
  }, [dispatch])

  return (
    <PageContainer>
      <Switch>
        <Route exact path="/" render={() => <Home />}/>
        <Route exact path="/gallery" render={() => <Gallery />}/>
        <Route exact path="/market" render={() => <Market />}/>
        <Route exact path="/wallet" render={() => <Wallet />}/>
        <Route exact path="/profile" render={() => <Profile />}/>
        <Route exact path="/mint" render={() => <Mint />}/>
        <Route path="/gallery/:id" render={() => <TokenView />}/>
        <Route path="/market/:id" render={() => <Market />}/>
        <Redirect from="*" to="/"/>
      </Switch>
    </PageContainer>
  )
}
